'use client';

import Image from 'next/image';
import {P} from './ui/P';
import {Sparkles} from 'lucide-react';
import React from "react";

export default function Owner() {
    return (
        <section className="max-w-custom mx-auto px-6 pb-10 mb-6">
            <P size={'l'} className={'text-gray-400 ml-6 lg:ml-3 my-6'}>
            Почему именно МЫ</P>
            <div
                className="relative bg-white/90 p-8 rounded-3xl shadow-md border border-gray-200 flex flex-col lg:flex-row gap-8 items-start lg:items-center transition-all duration-300 hover:shadow-lg">

                {/* Бейдж «Руководитель» */}
                <div
                    className="absolute top-4 right-4 flex items-center gap-1 bg-green-50 text-green-700 px-2 py-1 text-xs font-medium rounded-md border border-green-200">
                    <Sparkles size={14}/>
                    Старший специалист
                </div>

                {/* Фото директора */}
                <div className="w-36 h-36 shrink-0 rounded-2xl overflow-hidden">
                    <Image
                        src="/owner.png"
                        alt="Александр Иванов — директор агентства"
                        width={144}
                        height={144}
                        className="w-full h-full object-cover object-top"
                    />
                </div>

                {/* Текст */}
                <div className="flex-1 flex flex-col gap-4">
                    <P size="l" className="font-bold text-gray-900 leading-snug">
                        “Мы ценим ваше время, спокойствие и доверие”
                    </P>
                    <P size="s" className="text-gray-700">
                        Мы не просто продаём квартиры — мы ведём клиента от начала и до результата. Прозрачные условия,
                        сильная команда и забота на каждом шаге.
                    </P>
                    <div className="mt-2">
                        <p className="text-sm font-semibold text-gray-800">Портнягин Иван</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
